<template>
  <div>
    <div class="text-right mb-2">
      <v-btn
        v-if="!this.isFeatureEnabled('MAINTENANCE_MODE')"
        @click="
          logEvent('Clicked button to edit payment');
          newPaymentSession();
        "
        text
        color="primary"
        class="underline-btn"
      >
        <v-icon left>mdi-pencil</v-icon>
        View or Edit Payment Method
      </v-btn>
    </div>
    <v-data-table
      class="main-table"
      :headers="headers"
      :items="items"
      hide-default-footer
      disable-sort
      :options="tableOptions"
    >
      <template v-slot:item="{ item, index }">
        <tr :key="`payment-table-${index}`">
          <td>
            <span
              :class="`${getStatusColor(item.status)}--text`"
              class="highlight"
            >
              {{ getStatusLabel(item.status) }}
            </span>
          </td>
          <td>{{ item.amount | formatPrice }}</td>
          <td>{{ item.paymentDate | formatDate("LL") }}</td>
          <td>{{ getSubscriptionName(item) }}</td>
          <td class="text-right">
            <v-btn
              class="primary--text"
              color="secondary"
              depressed
              v-if="item.status === 'Success'"
              @click="
                logEvent('Clicked button to view invoice');
                downloadReceipt(item);
              "
            >
              <v-icon left>mdi-download</v-icon>
              Download
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div class="text-center pt-6">
      <v-btn
        height="32px"
        depressed
        class="load-btn px-2"
        :disabled="items.length === total"
        @click="loadData()"
      >
        Load More
      </v-btn>
      <p class="mt-2 mb-0 grey-text">
        Showing {{ this.items.length || 0 }} of {{ this.total || 0 }} invoices
      </p>
    </div>
  </div>
</template>

<script>
import { paymentsAPI } from "@/services/api";
import { get, getDownloadFilename, post } from "@/services/request";
import { saveFile } from "@/services/download";
import { formatPrice, formatDate } from "@/services/format";
import hasStatusFactory from "@/mixins/has-status-factory";
import hasNotifications from "@/mixins/has-notifications";

const tableOptions = {
  itemsPerPage: -1
};

const statusColorMap = {
  Success: "success",
  Failed: "error",
  Pending: "info"
};

const statusLabelMap = {
  Success: "PAID",
  Failed: "FAILED",
  Pending: "PENDING"
};

const VP_ENGAGE = "VP_ENGAGE";
const VP_ENGAGE_CVC = "VP_ENGAGE_CVC";
const subscriptionNames = {
  [VP_ENGAGE_CVC]: "VendorProof",
  [VP_ENGAGE]: "VendorProof Engage",
  VP_EMPLOYEE_MONITORING: "Employee Monitoring"
};

export default {
  name: "Payment",
  mixins: [hasStatusFactory(statusColorMap), hasNotifications],
  data: () => ({
    tableOptions,
    items: [],
    headers: [
      { text: "Payment Status", value: "status" },
      { text: "Payment Amount", value: "amount" },
      { text: "Payment Date", value: "paymentDate" },
      { text: "Subscription", value: "subscriptionType" },
      { text: " ", value: "action", align: "end" }
    ],
    total: 0
  }),
  created() {
    this._page = -1;
    this.loadData();
  },

  methods: {
    loadData() {
      get(paymentsAPI, {
        page: this._page + 1
      }).then(response => {
        if (response && response.data) {
          this.items = this.items.concat(response.data.content || []);
          this._page = "page" in response.data ? response.data.page : this.page;
          this.total =
            "total" in response.data ? response.data.total : this.total;
        }
      });
    },
    getSubscriptionName({ subscriptionType, clientName }) {
      const name = subscriptionNames[subscriptionType];
      return subscriptionType === VP_ENGAGE && clientName
        ? `${name}[${clientName}]`
        : name;
    },
    getStatusLabel(status) {
      return statusLabelMap[status] || "UNKNOWN";
    },
    downloadReceipt(item) {
      post(
        paymentsAPI,
        { ...item },
        {
          responseType: "blob",
          headers: {
            Accept: "application/pdf"
          }
        }
      )
        .then(response => {
          saveFile(response.data, getDownloadFilename(response));
        })
        .catch(e => console.error("Error downloading PDF", e));
    }
  },
  filters: {
    formatPrice,
    formatDate
  }
};
</script>

<style lang="sass" scoped></style>
